export default __webpack_public_path__ + "static/media/pic2.6b662761.jpg";